import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { getMyAdminStatus } from "@/lib/billing.functions";

export const Route = createFileRoute("/_authed/admin")({
  beforeLoad: async () => {
    // Skip admin gate during SSR: Supabase session lives in localStorage,
    // so getMyAdminStatus would 401 server-side. Client-side gate runs
    // after hydration when the session is available. Matches _authed.tsx.
    if (typeof window === "undefined") return;
    const status = await getMyAdminStatus();
    if (!status.isAdmin) throw redirect({ to: "/dashboard" });
  },
  component: AdminLayout,
});

function AdminLayout() {
  // Render-gate: the beforeLoad guard is skipped during SSR (session lives
  // in localStorage), so the admin shell would flash for non-admin visitors
  // during the post-hydration check-then-redirect window. Block render until
  // the client-side status resolves and confirms isAdmin.
  const { data, isPending } = useQuery({
    queryKey: ["admin-status-gate"],
    queryFn: () => getMyAdminStatus(),
    staleTime: 60_000,
  });
  if (isPending || !data?.isAdmin) return null;
  return <Outlet />;
}